
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ReservarPage = lazy(() => import('../pages/reservar/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/reservar',
    element: <ReservarPage />
  },
  {
    path: '/contacto',
    element: <ContactoPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
